import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import CustomPagination from "../../components/pagination";
import { countryService } from "../../utils/services/country.service.js";
import CountryModal from "../../components/country-modal/index.js";
import CountryList from "../../components/country-list/index.js";
import buildQuery from "../../utils/query-builder.js";

const initialState = {
  columns: [
    {
      name: "Name",
      key: "name",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      fetchApi: (searchKey, client_id, limit, skip) =>
        countryService.fetchCountryName(searchKey, client_id, limit, skip),
      loadMoreButton: true,
      searchKey: "",
    },
    {
      name: "Code2",
      key: "code2",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      fetchApi: (searchKey, client_id, limit, skip) =>
        countryService.fetchCountryCode2(searchKey, client_id, limit, skip),
      loadMoreButton: true,
      searchKey: "",
    },
    {
      name: "Code3",
      key: "code3",
      filter: [],
      sort: 0,
      id: "_id",
      displayKey: "_id",
      fetchApi: (searchKey, client_id, limit, skip) =>
        countryService.fetchCountryCode3(searchKey, client_id, limit, skip),
      loadMoreButton: true,
      searchKey: "",
    },
  ],
  limit: 15,
  //  populate: ["client_id"],
};
function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x,
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col,
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };

    default:
      return state;
  }
}

export default function Country() {
  const [countryData, setCountryData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [filterData, dispatch] = useReducer(filterReducer, initialState);
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(filterData.limit);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [clientFilter, setClientFilter] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState("list");

  const fetchCountryData = async () => {
    setLoading(true);
    try {
      const query = buildQuery(filterData, page); // Build filter/sort/pagination query
      const response = await countryService.fetch(searchValue, query); // Use updated fetch

      setCountryData(response.data);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, [page, clientFilter, searchValue, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_zone.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "340px" }}
      />
    </div>
  );

  return (
    <DashboardContainer
      searchBarPlaceholder={"Search by Country Name"}
      onSearchData={(p) => {
        setSearchValue(p);
        setPage(0);
      }}
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Country List"}
      onSelectClient={(e) => {
        setClientFilter(e);
      }}
      onChangeFilter={handleFilterChange}
      title={" + Country"}
      setViewMode={setViewMode}
      hideFilterClient
      filterData={filterData}
      fields={filterData.columns}
      onClickRefresh={() => fetchCountryData()}
    >
      <CountryModal
        selectedCountry={selectedCountry}
        handleClose={() => {
          setOpenModal(false);
          setSelectedCountry(null);
        }}
        open={openModal}
        onAddData={fetchCountryData}
      />
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}
      {countryData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <>
          <CountryList
            onDeleteData={() => fetchCountryData()}
            onEditData={(e) => {
              setSelectedCountry(e);
              setOpenModal(true);
            }}
            data={countryData}
            viewMode={viewMode}
            deleteTitle={"Delete Country"}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            currentPage={page}
            itemsPerPage={filterData.limit}
            onChangeFilter={handleFilterChange}
            filterData={filterData}
          />
        </>
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={filterData.limit}
        page={page}
        setPage={setPage}
        setRowsPerPage={(e) =>
          dispatch({ type: "UPDATE_LIMIT", payload: e })
        }
        disableNext={dataCount <= (page + 1) * filterData.limit}
      />
    </DashboardContainer>
  );
}
